import { gql } from '@apollo/client';

const setMcpEnabled = gql`
  mutation SetMcpEnabled($userId: ID!, $enabled: Boolean!) {
    setMcpEnabled(userId: $userId, enabled: $enabled)
  }
`;

export default setMcpEnabled;
